import CountryService from "../../../../services/CountryService";
import { CountryItem } from "../../../../redux/types";

class CountriesHelper {
  private _countryList: CountryItem[] = [];

  get countryList(): CountryItem[] {
    return this._countryList;
  }

  async fetchCountries(locale: string) {
    try {
      const countryList = await CountryService.getCountryList(locale);
      this._countryList = countryList.data.formDefinitionCountry;
    } catch (e) {
      throw new Error();
    }
  }

  async fetchCountriesWithMandatoryRegions(locale: string) {
    try {
      const [countryList, usaRegionsList, indiaRegionsList, australiaRegionList] = await Promise.all([
        CountryService.getCountryList(locale),
        CountryService.getCountryRegionsList("US"),
        CountryService.getCountryRegionsList("IN"),
        CountryService.getCountryRegionsList("AU")
      ]);

      const countries: CountryItem[] = countryList.data.formDefinitionCountry;
      const usaRegions = usaRegionsList.data.country.available_regions;
      const indiaRegions = indiaRegionsList.data.country.available_regions;
      const australiaRegions = australiaRegionList.data.country.available_regions;
      return { countries, usaRegions, indiaRegions, australiaRegions };
    } catch (e) {
      throw new Error();
    }
  }
}

export default new CountriesHelper();
